import api from '@/store/api'

const opts = { receive: false, save: false }

const bottleBotService = {
  listConversations({ cursor = null, limit = 30, platform = null } = {}) {
    const parts = []
    if (cursor) parts.push(`cursor=${cursor}`)
    parts.push(`limit=${limit}`)
    if (platform) parts.push(`platform=${platform}`)
    return api.call('GET', `ai/conversations?${parts.join('&')}`, {}, opts).then(r => r.data)
  },
  createConversation({ platform = null } = {}) {
    const body = platform ? { platform } : {}
    return api.call('POST', 'ai/conversations', body, opts).then(r => r.data)
  },
  renameConversation(id, title) {
    return api.call('PATCH', `ai/conversations/${id}`, { title }, opts).then(r => r.data)
  },
  deleteConversation(id) {
    return api.call('DELETE', `ai/conversations/${id}`, {}, opts).then(r => r.data)
  },
  listMessages(conversationId, { cursor = null } = {}) {
    const query = cursor ? `?cursor=${cursor}` : ''
    return api.call('GET', `ai/conversations/${conversationId}/messages${query}`, {}, opts).then(r => r.data)
  },
  createMessage(conversationId, content) {
    return api.call('POST', `ai/conversations/${conversationId}/messages`, { content }, opts).then(r => r.data)
  }
}

export default bottleBotService
